/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "Reality.Reality.Api";

/**
 * <strong>GET /api/v2/live2d/model/upload_url</strong>
 * ライブ2Dアップロード先の取得のAPI
 */
export interface Live2dModelUploadUrlResponse {
  uploadUrl: string;
}

function createBaseLive2dModelUploadUrlResponse(): Live2dModelUploadUrlResponse {
  return { uploadUrl: "" };
}

export const Live2dModelUploadUrlResponse = {
  encode(message: Live2dModelUploadUrlResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.uploadUrl !== "") {
      writer.uint32(10).string(message.uploadUrl);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Live2dModelUploadUrlResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLive2dModelUploadUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.uploadUrl = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Live2dModelUploadUrlResponse {
    return { uploadUrl: isSet(object.uploadUrl) ? globalThis.String(object.uploadUrl) : "" };
  },

  toJSON(message: Live2dModelUploadUrlResponse): unknown {
    const obj: any = {};
    if (message.uploadUrl !== "") {
      obj.uploadUrl = message.uploadUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Live2dModelUploadUrlResponse>, I>>(base?: I): Live2dModelUploadUrlResponse {
    return Live2dModelUploadUrlResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Live2dModelUploadUrlResponse>, I>>(object: I): Live2dModelUploadUrlResponse {
    const message = createBaseLive2dModelUploadUrlResponse();
    message.uploadUrl = object.uploadUrl ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
